import { useApiCall } from "@jane/lib/src/api";
import { Input } from "@jane/lib/src/components/form/Input";
import {FC, useState} from "react";
import {config} from "../config";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {IconStore} from "../../../lib/src/components/form/IconStore";
import {availableLearnIcons} from "../pages/learn/availableLearnIcons";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const EditLearnCategoryModal: FC<{ category: LearnCategory, reload: () => void }> = (props) => {
  const {learn} = useApiCall(config)
  const [name, setName] = useState(props.category.name ?? '')
  const [selectedIcon, setSelectedIcon] = useState<string>(props.category.icon ?? '')
  const save = async () => {
    await learn.editCategory(props.category.id, name, props.category.parent_category_id, props.category.is_pinned_category, selectedIcon)
    props.reload()
  }

  const icons = Object.entries(availableLearnIcons).filter(
    ([name, icon], index, self) =>
      self.findIndex(([_, i]) => i === icon) === index
  );
  return <div className={"flex flex-col space-y-3"}>
    <div className={'grid grid-cols-5'}>
      <div className={'col-span-3'}>
        <IconStore iconList={icons} selected={selectedIcon} setSelected={setSelectedIcon} />
      </div>
      <div className={'col-span-2 px-2'}>
        <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
      </div>
    </div>
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}